import logo from '../styles/heyart-logo-one-line.svg';

function NotFoundScreen() {
  return (
    <div id="not-found" className="full-screen">
      <h1 id='_404'>404</h1>
      <h2 id='not-found'>Page Not Found</h2>
    </div>
  )
}

export default NotFoundScreen;
